import axios from "axios";
import { useEffect, useState } from "react";

export const useAnmeldeDaten = (filter) => {

    const [anmeldeDaten, setAnmeldeDaten] = useState([{name: "", tel: "", email: "", text: ""}])
    
    useEffect(()=>{
        window.scrollTo(0, 0);
        axios.get("https://admin.lebenswirksamkeit-eg.at/api/kontaktes?populate=*&filters[projekt][$eq]=" + filter)
        .then((res) => {
            setAnmeldeDaten(res.data.data[0].attributes.anmeldedaten)
        })
        .catch((err) => console.log(err))
      }, [filter])

    return anmeldeDaten
}
